// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { lastDayOfYear as fn } from "../lastDayOfYear.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const lastDayOfYear = convertToFP(fn, 1);

// Fallback for modularized imports:
export default lastDayOfYear;
